module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><path d=\"M170.7 256L448 448V64L170.7 256zM64 64h64v384H64z\"></path></svg>"